export default __webpack_public_path__ + "static/media/ico_save.2f50cede.svg";